// Footer.js
"use client";
import { useEffect, useState } from "react";
import FooterClient from "./FooterClient";
import { getFooterData, getSubMenuData } from "../utils/services/navigation";

export default function Footer() {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchFooter() {
      const [footerData, profilLinks, publikasiLinks] = await Promise.all([
        getFooterData(),
        getSubMenuData("?filters[url_submenu][$contains]=profil"),
        getSubMenuData("?filters[url_submenu][$contains]=publikasi"),
      ]);
      setData({
        footerData: footerData.data,
        profilLinks: profilLinks.data,
        publikasiLinks: publikasiLinks.data,
      });
    }
    fetchFooter();
  }, []);

  if (!data) return null; // placeholder skeleton

  return (
    <FooterClient
      initialFooters={data.footerData}
      initialProfilLinks={data.profilLinks}
      initialPublikasiLinks={data.publikasiLinks}
    />
  );
}
